import DeleteDialog from '../Dashboard/PostsTable/DeleteDialog';
import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import { red } from '@mui/material/colors';

const redTheme = createTheme({
  palette: {
    primary: red,
  },
});

export default function PostDeleteBtn({ onDelete, permlink }) {
  const [deleteOpen, setDeleteOpen] = useState();

  const handleDelete = () => {
    setDeleteOpen(permlink);
  };

  return (
    <>
      <div className="tw-mx-1">
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={redTheme}>
            <Button
              // className="p-0 pl-2 pr-2"
              variant="outlined"
              color="primary"
              onClick={handleDelete}
            >
              <DeleteIcon />
              <span className="textPrimary pl-1 tw-hidden sm:tw-block">
                Delete
              </span>
            </Button>
          </ThemeProvider>
        </StyledEngineProvider>
      </div>
      <DeleteDialog
        btnText="Delete Post Forever"
        dialogText="If you delete this post, it will be gone forever and cannot be restored. Deleting the post will not delete it from third-party platforms if you used cross-posting."
        setOpen={setDeleteOpen}
        permlink={deleteOpen}
        onDelete={onDelete}
      />
    </>
  );
}
